export const WIDGET_TYPES = {
  plainWidget: 'plain_widget',
  attributeColumnizeWidget: 'attribute_columnize_widget',
  attributeWidget: 'attribute_widget',
  plainCollapsableWidget: 'plain_collapsable_widget',
  parentWidget: 'parent_widget',
  attributeImageWidget: 'attribute_image_widget',
  aplusWidget: 'aplus_widget',
};
